import { ONE_HOUR, ONE_SECOND } from '@air/utilities';

export const SOCKET_RECONNECT_MAX_DELAY_MS = ONE_HOUR;
export const SOCKET_RECONNECT_DELAY_BASE_MS = ONE_SECOND;
export const SOCKET_RECONNECT_JITTER_FACTOR = 0.2;

export type GetSocketReconnectDelayMsParams = {
  attempt: number;
  random?: () => number;
};

/**
 * Wait before a socket connect attempt. `attempt` is 0-based (first try waits 0ms).
 * Delay is `attempt²` seconds, capped at 1 hour, then multiplied by 1.0–1.2 jitter.
 */
export const getSocketReconnectDelayMs = ({
  attempt,
  random = Math.random,
}: GetSocketReconnectDelayMsParams): number => {
  const retryDelay = attempt ** 2 * SOCKET_RECONNECT_DELAY_BASE_MS;
  const delayWithoutRandom = retryDelay < SOCKET_RECONNECT_MAX_DELAY_MS ? retryDelay : SOCKET_RECONNECT_MAX_DELAY_MS;

  return delayWithoutRandom * (random() * SOCKET_RECONNECT_JITTER_FACTOR + 1);
};
